<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-spectrum/view';
import {HeaderInfo, PropTable} from '@react-spectrum/docs';
import packageData from '@react-spectrum/view/package.json';

```jsx import
import {Content} from '@react-spectrum/view';
```

---
category: Content
---

# Content

<p>{docs.exports.Content.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['Content']} />

## Examples

```tsx example
<Content>Try another search</Content>
```

## Content

The Content component is used as a child to other components. Based on the
component it is used within, it gets Spectrum styling and may have a preassigned
slot for positioning. By virtue of its name, the Content component provides
semantic meaning in the context they are placed. An example of this is
explained in [Dialog](Dialog.html#content) and it is also used by
[IllustratedMessage](IllustratedMessage.html#example). It is important to note
that the Content element accepts any renderable node, not just strings.

A Content is used to specify the content of a component. Example usage can be found in
[Dialog](Dialog.html#example) and [IllustratedMessage](IllustratedMessage.html#example).

## Props

<PropTable component={docs.exports.Content} links={docs.links} />
